module.exports = __webpack_public_path__ + "img/unsubscribe.a9e0fb06.jpg";